import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';
import './index.css';
import "bootstrap/dist/css/bootstrap.min.css";
const renderWebsite = () => {
  const doc = document.getElementById('root');
  if(doc) {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
          <App />
      </React.StrictMode>
    );
  }
};

// Check if the app is running as a widget or standalone website
// if (isWidgetMode === false) {
  // If renderWidget is not called, it will render as a website by default
  renderWebsite();
// }


// Optionally, measure app performance
reportWebVitals();
